import classNames from "classnames"
import type React from "react"
import { Icon, type IconSources } from "../Icon"
import { withFieldLabelAndHint } from "./field"
import type { FormElement } from "./form"

export type TextInputType =
  | "text"
  | "email"
  | "number"
  | "password"
  | "search"
  | "tel"
  | "url"
  | "date"
  | "datetime-local"
  | "month"
  | "time"
  | "week"
  | "currency"

type Props = {
  type?: TextInputType
  icon?: IconSources
  forwardedRef?: React.Ref<HTMLInputElement>
} & FormElement &
  React.InputHTMLAttributes<HTMLInputElement>

export const TextInputWrapper = ({
  icon,
  status,
  render,
}: {
  icon?: IconSources
  status?: FormElement["status"]
  render: (className: string) => React.ReactNode
}) => {
  return (
    <div
      className={classNames("cobalt-TextField", {
        "cobalt-TextField--withIcon": icon,
        "cobalt-TextField--success": status === "success",
        "cobalt-TextField--error": status === "error",
      })}
    >
      {render("cobalt-TextField__Input")}
      {icon && <Icon source={icon} className="cobalt-TextField__Icon" />}
    </div>
  )
}

const TextInput = ({
  icon,
  status,
  type = "text",
  forwardedRef,
  ...inputProps
}: Props) => (
  <TextInputWrapper
    icon={icon}
    status={status}
    render={(className) => {
      return (
        <input
          type={type}
          {...inputProps}
          className={className}
          ref={forwardedRef}
        />
      )
    }}
  />
)

TextInput.displayName = "TextInputRaw"

const wrappedComponent = withFieldLabelAndHint(TextInput)
wrappedComponent.displayName = "TextInput"

export { wrappedComponent as TextInput }
